import React from 'react';
import {
  Box, Button, CircularProgress, Typography,
} from '@mui/material';
import useCustomMediaQuery from '../../hooks/useCustomMediaQuery';

const innerButtonSx = {
  position: 'relative',
  borderRadius: '8px',
  height: '58px',
  fontSize: '16px',
};

export default function CustomButton({
  isLoading,
  children,
  loadingText,
  disabled,
  onClick,
  color,
  variant = 'contained',
  sx,
  startIcon,
  endIcon,
  download,
  href,
  target,
  htmlFor,
  component,
}) {
  const { isMobileTablet } = useCustomMediaQuery();

  const mobileTabletStyle = isMobileTablet ? { height: 42, fontSize: 14 } : {};

  const displayText = isLoading && loadingText ? loadingText : children;

  return (
    <Button
      sx={{ ...innerButtonSx, ...sx, ...mobileTabletStyle }}
      download={download}
      component={component}
      htmlFor={htmlFor}
      target={target}
      href={href}
      disabled={Boolean(disabled) || Boolean(isLoading)}
      color={color}
      startIcon={!isLoading && startIcon}
      endIcon={!isLoading && endIcon}
      variant={variant}
      onClick={onClick}
    >
      {isLoading && <CircularProgress sx={!loadingText ? { position: 'absolute' } : { marginRight: '10px' }} size="1rem" />}
      <Box visibility={isLoading && !loadingText ? 'hidden' : 'visible'}>
        {typeof displayText === 'string' ? (
          <Typography fontSize={isMobileTablet ? 14 : undefined}>{displayText}</Typography>
        ) : displayText}
      </Box>
    </Button>
  );
}
